<template>
  <div>
    <PCNavbar selectIndex="1" :currentIndex="currentIndex" :section3ScrollTop="section3ScrollPosition"/>
    <!-- <MobileNavBar :currentActive="1" /> -->
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1" @click="closeChat">
          <div class="section-content_1">
            <img class="topBT" src="@/assets/img/home/top_b.png" alt="">
            <img class="topBigCenter" 
              :class="{'chat-expanded': isChatExpanded}" 
              src="@/assets/img/home/bigCenter.png" 
              alt=""
              @mouseenter="showTips = true"
              @mouseleave="showTips = false"
            >
            <div class="text_1_view"></div>
            <div class="tips_1" v-show="showTips && !isChatExpanded">
              <div class="tips_1_text"><span>蓝脚鲣鸟</span>以其一双醒目的亮蓝色脚蹼而闻名，是海洋生态环境健康的“指示物种”。它们通过捕食鱼类并将富含氮、磷的粪便带回岛屿，促进了海洋与陆地之间的营养物质循环</div>
            </div>
            <div class="tips_2" v-show="showTips && !isChatExpanded">
              <div class="tips_2_text">这种高效的<span>生态循环</span>本身即是自然碳汇系统的一部分，对维持海洋生态平衡、间接助力碳中和具有独特意义</div>
            </div>
            <div class="section-1_bottom">
              <img class="bottom_left_img" src="@/assets/img/home/bottom_left_img.png" alt="">
              <img class="bottom_center_img" src="@/assets/img/home/bottom_center_img.png" alt="">
              <img class="bottom_right_img" src="@/assets/img/home/bottom_right_img.png" alt="">
              <div class="bottom_left_view">
                <div class="bottom_left_view_title">用AI重新定义碳中和之路</div>
                <div class="bottom_left_view_text">• 全球首个碳中和领域72B垂类大模型</div>
                <div class="bottom_left_view_text">• 实现从碳足迹追踪到碳中和决策的全流程自主优化</div>
                <div class="bottom_left_view_text">• 提供颠覆性的碳管理解决方案</div>
                <div class="bottom_left_view_text">• 引领着行业正式进入AI时代</div>
                <div class="bottom_left_view_text_other" @click="gotAboutUs">关于我们</div>
              </div>
              <div class="bottom_chat" :class="{'bottom_chat_expanded': isChatExpanded}" :key="'bottom_chat_' + isChatExpanded">
                <div class="bottom_chat_view" :class="{'bottom_chat_view_expanded': isChatExpanded}">
                  <div class="bottom_chat_view_t">
                    <div class="bottom_chat_view_t_chat">
                      <div 
                        class="chat-messages-container" 
                        ref="chatMessagesContainer"
                        @wheel="handleChatScroll"
                      >
                        <div 
                          v-for="(message, index) in messages" 
                          :key="index"
                          :class="['chat-message', message.isUser ? 'user-message' : 'bot-message']"
                        >
                          <!-- 用户消息图标 -->
                          <div v-if="message.isUser" class="message-icons">
                            <div class="message-content" v-html="message.displayText || message.content"></div>
                            <img class="message-icon message-icon-after" src="@/assets/img/home/user-icon.png" alt="用户">
                          </div>
                          
                          <!-- AI消息图标 -->
                          <div v-else class="message-icons">
                            <img class="message-icon message-icon-before" src="@/assets/img/home/ai-icon.png" alt="AI">
                            <template v-if="message.isLoading">
                              <div>正在生成中...</div>
                            </template>
                            <template v-else>
                              <div class="message-content" v-html="message.displayText || message.content"></div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bottom_chat_view_b">
                    <el-input 
                      type="textarea"
                      class="el-textarea_view"
                      placeholder="携手开启零碳之旅……"
                      v-model="newMessage"
                      @keydown.native="handleKeyDown"
                      @keyup.native="handleKeyUp"
                      @focus="expandChat"
                    >
                    </el-input>
                    <div class="bottom_chat_send" :class="{'wecome_container_content_send_disabled': !newMessage}" @click="sendMessage">
                        <img class="bottom_chat_send_icon" src="@/assets/img/home/send.png" alt="send"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom_right_view">
                <img class="bottom_right_view_img" src="@/assets/img/home/bottom_right_view_img.png" alt="">
                <div class="bottom_right_view_view">
                  <el-carousel :interval="3000" indicator-position="outside" arrow="never" trigger="click">
                    <el-carousel-item v-for="(item,index) in carouselData" :key="index">
                      <div class="bottom_right_view_view_v">
                        <div class="bottom_right_view_view_v_title">{{ item.title }}</div>
                        <div class="bottom_right_view_view_v_title_other">{{ item.subtitle }}</div>
                        <div class="bottom_right_view_view_v_info">
                          <div v-for="(info, infoIndex) in item.infoList" :key="infoIndex">{{ info }}</div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <!-- 第二屏 -->
        <!-- <section class="fullpage-section section-2">
          <div class="section-2_lowest"></div>
          <img class="section-2_img" src="@/assets/img/home/section-2_img.png" alt="">
          <img class="section-2_hover" src="@/assets/img/home/section-2_hover.png" alt="">
          <img class="section-content_2" src="@/assets/img/home/section-content_2.png" alt="">
          <div class="section-2_text">用AI<br>重新定义碳中和之路</div>
          <div class="section-2_top">
            <div class="section-2_top_l">
              <div class="section-2_top_l_title">80000+</div>
              <div class="section-2_top_l_info">人工撰写高精度行业QA数据</div>
              <div class="section-2_top_l_title">10000+</div>
              <div class="section-2_top_l_info">条行业专业知识</div>
              <div class="section-2_top_l_title">15万+</div>
              <div class="section-2_top_l_info">实时更新排放因子，覆盖全球主流因子库</div>
            </div>
            <div class="section-2_top_r">
              <div class="section-2_top_l_title">700亿+</div>
              <div class="section-2_top_l_info">高精度参数 “碳中枢”底座</div>
              <div class="section-2_top_l_title">ToG / ToB / ToC</div>
              <div class="section-2_top_l_info">三端全面服务</div>
              <div class="section-2_top_l_title rLine"></div>
              <div class="section-2_top_l_info flexStyle">
                <span>看见未来</span>
                <span>拥抱未来</span>
                <span>改变未来</span>
              </div>
            </div>
          </div>
          <div class="section-2_bottom">
            <div class="section-2_bottom_l">
              <div class="section-2_bottom_l_title">政企民协同解决方案矩阵</div>
              <div class="section-2_bottom_l_info">以“技术+模式+人才”的三重优势，构建了面向政府、企业、公众的碳中和全生命周期解决方案，引领着双碳由数字化向AI化变革。</div>
              <div class="section-2_bottom_l_view">
                携手开启零碳之旅...
                <img class="section-2_bottom_l_view_img" src="@/assets/img/home/sendOther.png" alt="">
              </div>
            </div>
            <div class="section-2_bottom_r">
              <div class="section-2_bottom_r_view">
                <div class="borderLine" style="width: 275px;"></div>
                <div class="section-2_bottom_r_view_v">
                  <div class="section-2_bottom_r_view_title">G端<span>智慧治理</span></div>
                  <div class="section-2_bottom_r_view_info">提供<span>区域级</span>能碳管控/预测/优化/预警平台工具或解决方案，助力政府构建<span>精准化双碳治理体系</span>。</div>
                </div>               
              </div>
              <div class="section-2_bottom_r_view">
                <div class="borderLine" style="width: 435px;"></div>
                <div class="section-2_bottom_r_view_v">
                  <div class="section-2_bottom_r_view_title">B端<span>产业赋能</span></div>
                  <div class="section-2_bottom_r_view_info"><span>“碳中枢”AI Agent</span>实现从碳核算到交易的全业务<span>流程AI化</span>，为企业<span>绿色低碳</span>可持续发展提供<span>AI+引擎</span>。</div>
                </div>
              </div>
              <div class="section-2_bottom_r_view">
                <div class="borderLine" style="width: 100%;"></div>
                <div class="section-2_bottom_r_view_v">
                  <div class="section-2_bottom_r_view_title">C端<span>行为革命</span></div>
                  <div class="section-2_bottom_r_view_info">通过AI智能个人碳账户平台结合多元减排场景与<span>可持续先锋计划</span>，量化低碳生活实践，助力<span>全民低碳参与网络</span>形成。</div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        
        <!-- 第三屏 -->
        <section class="fullpage-section section-3">
          <vue-particles
            :particleOpacity="0.7"
            :particlesNumber="50"
            shapeType="circle"
            :particleSize="1"
            linesColor="#AADBFF"
            :linesWidth="1"
            :lineLinked="true"
            :lineOpacity="0.4"
            :linesDistance="150"
            :moveSpeed="3"
            :hoverEffect="true"
            hoverMode="grab"
            :clickEffect="true"
            clickMode="push">
          </vue-particles>
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 2 }">
            <div class="section-3-content">
              <div class="section-3-content_top">
                <div class="section-3-content_top_view">
                  <div class="section-3-content_top_view_top">我们的选择<br>决定地球的未来</div>
                  <div class="section-3-content_top_view_line"></div>
                  <div class="section-3-content_top_view_bottom">天不言而四时行，地不语而百物生</div>
                </div>
              </div>
              <SCurveComponent />
            </div>
          </div>
        </section>
        
        <!-- 第四屏 -->
        <!-- <section class="fullpage-section section-4">
          <div class="section-content">
            <h2>第四屏</h2>
            <p>这是最后一屏</p>
          </div>
        </section> -->
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import SCurveComponent from '@/components/home/index.vue'
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import katex from "katex";
import mkatex from "markdown-it-katex";
import "katex/dist/katex.min.css";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import {
  guestLogin
} from "@/api";

import http from "@/utils/http";
// 配置 markdown-it
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<div class="code-block">
                  <pre class="hljs"><code class="language-${lang}">${
          hljs.highlight(str, { language: lang, ignoreIllegals: true }).value
        }</code></pre>
                </div>`;
      } catch (__) {
        // 忽略错误，使用默认渲染
      }
    }
    return `<pre class="hljs"><code>${md.utils.escapeHtml(str)}</code></pre>`;
  },
});

// md.use(markdownItEcharts, { echarts });
md.use(mkatex);

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    SCurveComponent
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 2, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      newMessage: "",
      carouselIndex: 0, // 轮播当前索引
      carouselInterval: null, // 轮播定时器
      isSection3Scrolling: false, // 第三屏内部是否正在滚动
      section3ScrollPosition: 0, // 第三屏内部滚动位置
      carouselData: [
        {
          title: "“碳芯”大模型",
          subtitle: "全球首个双碳领域垂类大模型（闭源）",
          infoList: [
            "• ≥ 15万条 联合国/国家/行业/地方排放因子库",
            "• ≥700亿 模型参数量",  
            "• ≥8万条 独家人工高精度专业语料",
            "• 覆盖范围一、二、三",
            "• >65%专业能力提升（与通用大模型相比）"
          ]
        },
        {
          title: "碳盘查Agent",
          subtitle: "企业碳排放核算的\"秒级引擎\"",
          infoList: [
            "• 极速合规｜AI自动规划，盘查从\"月级\"变\"秒级\"",
            "• 智能降本｜全流程自动解析，成本降幅90%+",  
            "• 精准可信｜15万条行业因子库，准确率95%以上",
            "• 一键报告｜专属定制化碳盘查报告与减排建议"
          ]
        },
        {
          title: "碳足迹Agent",
          subtitle: "产品碳排放全生命周期的智能核算专家",
          infoList: [
            "• 通行全球｜轻松应对CBAM与多国碳标签标准",
            "• 精准建模｜复杂工艺场景，AI自动建模计算",  
            "• 高效低耗｜数据自动溯源与校验，效率提升70%+",
            "• 碳热点可视｜减排路径与改进方向一目了然"
          ]
        }
      ],
      chatMessages: [
        {
          type: 'bot',
          content: '您好！我是碳中枢AI助手，很高兴为您服务。请问有什么可以帮助您的吗？',
          timestamp: new Date()
        }
      ],
      isChatScrolling: false,
      isTyping: false, // 是否正在输入中
      eventSource: null, // 新增 EventSource 实例变量
      fullResponse: "", // 用于存储完整的回复内容
      controller: null, // 用于控制响应的 AbortController
      conversationId: "",
      requestData: {
        inputs: {
          language: "zh-CN",
        },
        query: "",
        response_mode: "streaming",
        conversation_id: "",
        user: "",
        files: []
      },
      messages: [],
      isChatExpanded: false, // 控制聊天框是否展开
      showTips: false,
    };
  },
  mounted() {
    // // 启动轮播自动播放
    // this.startCarousel();
    // 添加触摸板支持
    this.addTrackpadSupport();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    // this.stopCarousel();
    // 移除触摸板支持
    this.removeTrackpadSupport();
  },
  methods: {
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第三屏，优先处理内部滚动
      if (this.currentIndex === 1) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第三屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      
      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 处理聊天容器滚动
     */
    handleChatScroll(e) {
      const chatContainer = this.$refs.chatMessagesContainer;
      if (!chatContainer) return;

      const scrollTop = chatContainer.scrollTop;
      const clientHeight = chatContainer.clientHeight;
      const scrollHeight = chatContainer.scrollHeight;
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用容差）
      const isAtTop = scrollTop <= 5;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      
      // 如果不在边界，允许聊天容器自然滚动
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
        // 不阻止默认行为，让聊天容器处理自然滚动
        this.isChatScrolling = true;
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      e.stopPropagation();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        this.isChatScrolling = false;
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
        this.isScrolling = true;
        this.currentIndex = index;
        
        // 滚动动画结束后重置状态
        setTimeout(() => {
            this.isScrolling = false;
        }, this.transitionDuration);
    },

    // 处理键盘松开事件
    handleKeyUp(event) {
      if(this.isResponding) return; // 如果正在响应，则不处理键盘事件
      if (event.shiftKey && event.key === "Enter") {
        // Shift+Enter 换行
        return;
      }
      if (event.key === "Enter") {
        this.sendMessage(false); // 单独按 Enter
      }
    },
    
    // 处理键盘按下事件
    handleKeyDown(event) {
      // 如果按下Enter但没有按Shift，阻止默认换行行为
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
      }
    },

    closeChat(){
      const chatElement = this.$el.querySelector('.bottom_chat');
      if (chatElement && chatElement.contains(event.target)) {
        return;
      }
      
      this.isChatExpanded = false;
      this.scrollToBottom();
    },

    // 发送消息
    sendMessage(keepTrailingLineBreaks = true) {
      if (!this.newMessage.trim() || this.isResponding) return;
      
      // 动态改变聊天框尺寸
      // this.expandChat();

      const message = keepTrailingLineBreaks 
        ? this.newMessage 
        : this.newMessage.replace(/\n+$/, ''); // 去除末尾的换行符，保留中间的换行符         
      const userMsg = {
        content: message,
        isUser: true,
        isTyping: false,
        files: this.requestData.files,
      };
      this.newMessage = "";
      this.lastUserMessage = message;
      this.messages.push(userMsg);
      this.scrollToBottom();
      this.getAIResponse();
    },

    // 展开聊天框
    expandChat() {
      this.$nextTick(() => {
        this.isChatExpanded = true;
        
        // 强制重新渲染，确保样式生效
        this.$forceUpdate();
        
        // 添加延迟，确保样式完全应用
        setTimeout(() => {
          // 滚动到底部
          this.scrollToBottom();
          this.focusInput();
        }, 50);
      });
    },

    focusInput() {
      const inputElement = this.$el.querySelector('.el-textarea_view textarea');
      if (inputElement) {
        inputElement.focus();
      }
    },

    // 确保获取有效的 token
    async ensureToken() {
      let storeToken = localStorage.getItem("token");
      if (!storeToken) {
        try {
          const response = await guestLogin();
          const { token } = response.data.data;
          this.user_id = response.data.data.user_id;
          this.requestData.user = this.user_id;
          storeToken = token;
          localStorage.setItem("token", token);
          localStorage.setItem("user_id", this.user_id);
        } catch (error) {
          this.messages.pop(); // 删除加载效果消息
          // this.messages.push({
          //   content: "获取token失败，请刷新页面重试",
          //   isUser: false,
          //   isTyping: false,
          //   isLoading: false,
          // });
          throw error;
        }
      }
      return storeToken;
    },

    // 获取AI回复
    async getAIResponse() {
      this.requestData.query = this.lastUserMessage;
      this.conversation_id = this.conversationId;
      try {
        const token = await this.ensureToken();
        this.requestData.user = localStorage.getItem("user_id");
        this.requestData.access_type = "ai";
        let aiMsg = {
          content: "",
          displayText: "",
          isUser: false,
          isTyping: true,
          isLoading: true,
        };
        
        if(this.messages.length > 0 && this.messages[this.messages.length - 1].isLoading){
          this.messages.pop(); // 删除上一个消息
        }
        
        this.messages.push(aiMsg);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const baseURL = http.defaults.baseURL;
        const url = `${baseURL}/pack/chatMessages`;        

        await fetchEventSource(url, {
          method: "POST",
          signal: signal,
          reconnect: false, // 不自动重连
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "accept-language": "zh-CN"
          },
          body: JSON.stringify(this.requestData),
          openWhenHidden: true,
          onmessage: (event) => {
            const data = JSON.parse(event.data);
            this.conversationId = data.conversation_id || this.conversationId;        
            if (data.event === "done") {
              this.$nextTick(() => {
                const formattedResponse = this.formatMessage(this.fullResponse);
                aiMsg.displayText = formattedResponse;
                aiMsg.isLoading = false;
                this.messages[this.messages.length - 1] = aiMsg;
              });
              return;
            } else if (data.event === "error") {
              this.messages.push({
                content: "222",
                isUser: false,
                isTyping: false,
                isLoading: false,
              });
              this.isResponding = false;
              this.scrollToBottom();
              return;
            }
            if (data.event.trim() === "" || data.event === "ping") return;
            if (data.answer) {
              this.fullResponse += data.answer;
              const formattedResponse = this.formatMessage(this.fullResponse);
              aiMsg.displayText = formattedResponse;
              aiMsg.isLoading = false;
              this.messages[this.messages.length - 1] = aiMsg;
              this.scrollToBottom();
            }
          },
          onclose: () => {
            this.isResponding = false;
          },
          onerror: (error) => {
            this.messages.push({
              content: "",
              isUser: false,
              isTyping: false,
              isLoading: false,
            });
            this.isResponding = false;
            this.scrollToBottom();
            throw error; // 处理错误
          },
          onopen: async (response) => {
            if (response.status == 401) {
              // 清除旧的token
              localStorage.removeItem("token");
              localStorage.removeItem("user_id");
              this.getAIResponse()
              // this.messages.push({
              //   content: "请重新提交",
              //   isUser: false,
              //   isTyping: false,
              //   isLoading: false,
              // });
              this.isResponding = false;
              // handleLogout();
            }
          },
        })
      } catch (error) {
        if(error == "TypeError: network error"){
          // this.stopResponse();
        }
        this.messages.push({
          content: "",
          isUser: false,
          isTyping: false,
          isLoading: false,
        });
      }
    },

    // 格式化消息内容
    formatMessage(text) {
      if (!text) return "";

      // 自定义链接渲染规则
      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        const hrefIndex = token.attrIndex("href");
        if (hrefIndex >= 0) {
          const href = token.attrs[hrefIndex][1];
          const hasTarget = this.checkUrlContainsPath(href, 'ai_open_file');
          if (hasTarget) {
            //假设fileId是会话id，用于后期传参
            const fileId = href.split('/').pop();
            // const buttonHtml = `<button class="excel-view-btn" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</button>`;
            const buttonHtml = `<span class="span-link" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</span>`;

            // 2. 标记当前链接为特殊链接
            token.attrSet('is-special-link', 'true');

            // 3. 清空后续文本token内容（原始URL）
            if (tokens[idx + 1] && tokens[idx + 1].type === 'text') {
              tokens[idx + 1].content = ''; // 关键：清除URL文本
            }

            return buttonHtml;
          } else {
            token.attrSet("target", "_blank");
            token.attrSet("rel", "noopener noreferrer");
          }
        }
        return self.renderToken(tokens, idx, options);
      };

      md.renderer.rules.link_close = (tokens, idx, options, env, self) => {
        // 获取对应打开标签token（link_close在link_open后2个位置）
        const linkOpenToken = tokens[idx - 2];
        if (linkOpenToken && linkOpenToken.attrGet('is-special-link') === 'true') {
          return ''; // 特殊链接不渲染闭合标签
        }
        return self.renderToken(tokens, idx, options); // 普通链接正常渲染
      };

      // 自定义数学公式渲染规则
      const renderMath = (content, displayMode) => {
        try {
          return katex.renderToString(content, { displayMode });
        } catch (error) {
          return displayMode ? `$$${content}$$` : `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-行内公式
      md.renderer.rules.math_inline = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: false });
        } catch (error) {
          return `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-块级
      md.renderer.rules.math_block = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: true });
        } catch (error) {
          return `$$${content}$$`;
        }
      };

      // 渲染数学公式
      text = text.replace(/\\\[/g, "$$").replace(/\\\]/g, "$$"); // 替换 \[ 和 \] 为 $$
      text = text.replace(/\\\(/g, '$').replace(/\\\)/g, '$') // 替换 \( 和 \) 为 $
      text = text
        .replace(/\$\$([\s\S]*?)\$\$/g, (_, formula) =>
          renderMath(formula, true)
        )
        .replace(/\$([^$]*?)\$/g, (_, formula) => renderMath(formula, false));

      // 如果\n后面紧跟数字, 转换为 \n 1
      text = text.replace(/\n(\d+)/g, "\n $1 ");

      // 渲染 ECharts 图表
      // text = text.replace(/```echarts([\s\S]*?)```/g, (_, option) => {
      //   const containerId = `echarts-${Math.random()
      //     .toString(36)
      //     .substr(2, 9)}`;
      //   setTimeout(() => {
      //     const container = document.getElementById(containerId);
      //     console.log("是否获取到container", container)
      //     if (container) {
      //       const chart = echarts.init(container);
      //       chart.setOption(JSON.parse(option));
      //     }
      //   });
      //   return `<div id="${containerId}" class="echarts-container"></div>`;
      // }, 100);

      return md.render(text);
    },

    // 滚动到对话底部
    scrollToBottom() {
      // if (this.$refs.chatMessagesContainer) {
      //   const container = this.$refs.chatMessagesContainer;
      //   container.scrollTop = container.scrollHeight;
      // }
      this.$nextTick(() => {
        const container = this.$refs.chatMessagesContainer;
        if (container?.scrollHeight) {
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight;
          });
        }
      });
    },

    // 轮播相关方法
    // startCarousel() {
    //   this.carouselInterval = setInterval(() => {
    //     this.nextCarouselSlide();
    //   }, 5000); // 每5秒自动切换
    // },

    // stopCarousel() {
    //   if (this.carouselInterval) {
    //     clearInterval(this.carouselInterval);
    //     this.carouselInterval = null;
    //   }
    // },

    // nextCarouselSlide() {
    //   this.carouselIndex = (this.carouselIndex + 1) % this.carouselData.length;
    // },

    // goToCarouselSlide(index) {
    //   this.carouselIndex = index;
    //   // 点击指示器时重置定时器
    //   this.stopCarousel();
    //   this.startCarousel();
    // },

    gotAboutUs() {
      this.$router.push('/about');
    }
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.topBigCenter{
  width: 787px;
  max-height: calc(100vh - 225px);
  position: absolute;
  bottom: 0px;
  left: 488px;
  z-index: 3;
  object-fit: contain;
  // overflow: hidden;
  // clip-path: inset(0 0 50px 0);
  transition: all 0.5s cubic-bezier(0.34, 1.02, 0.64, 1); /* 使用弹性缓动函数 */
  transform-origin: center bottom; /* 设置变换原点为底部中心 */

  &:hover:not(.chat-expanded) {
    transform: scale(1.01) translateY(-10px);
  }

  /* 鼠标移出时的反向动画 */
  .topBigCenter:not(:hover):not(.chat-expanded) {
    animation: bounceDown 0.4s cubic-bezier(0.34, 1.02, 0.64, 1) forwards;
  }

  @keyframes bounceDown {
    0% {
      transform: scale(1.01) translateY(-10px);
    }
    30% {
      transform: scale(0.95) translateY(5px); /* 反向过冲 */
    }
    60% {
      transform: scale(1.02) translateY(-2px); /* 回弹 */
    }
    100% {
      transform: scale(1) translateY(0); /* 恢复原状 */
    }
  }
}

.text_1_view{
  width: 100%;
  height: 360px;
  position: absolute;
  bottom: 0px;
  left: 0;
  overflow: hidden;
  z-index: 4;
}

.text_1_view::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  mask-image: linear-gradient(to bottom, transparent 0%, black 30%, black 100%);
  -webkit-mask-image: linear-gradient(to bottom, transparent 0%, black 30%, black 100%);
}

.tips_1{
  width: calc(100% * 560 / 1920);
  height: calc(100% * 215 / 1080);
  position: absolute;
  top: calc(100% * 443 / 1080);
  left: calc(100% * 257 / 1920);
  z-index: 2;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;

  .tips_1_text{
    font-size: 16px;
    color:#fff;
    font-weight: 300;
    line-height: 38px;
    width: calc(100vw * 376 / 1920);
    height: calc(100vh * 158 / 1080);

    span{
      font-size: 32px;
      font-weight: 700;
    }
  }
}

.tips_2{
  width: calc(100vw * 600 / 1920);
  height: calc(100% * 160 / 1080);
  position: absolute;
  top: calc(100% * 380 / 1080);
  right: calc(100% * 295 / 1920);
  z-index: 2;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;

  .tips_2_text{
    font-size: 16px;
    color:#fff;
    font-weight: 300;
    line-height: 38px;
    width: calc(100vw * 446 / 1920);
    height: calc(100vh * 82 / 1080);

    span{
      font-size: 32px;
      font-weight: 700;
    }
  }
}

.section-1_bottom{
  height: calc(100% * 460 / 1080);
  left:105px;
  bottom: calc(100% * 58 / 1080);
  width: calc(100% - 215px);
  position: absolute;
  z-index: 5;

  .bottom_left_img{
    position: absolute;
    left: 0;
    bottom:0;
    width: calc(100vw * 825 / 1920);
    height: calc(100vh * 250 / 1080);
  }

  .bottom_center_img{
    position: absolute;
    left: 50%;
    top: calc(100vh * 170 / 1080);
    transform: translate(-50%, 0);
    width: 70px;
    height: 70px;
  }

  .bottom_right_img{
    position: absolute;
    right: 0;
    top:0;
    width: calc(100vw * 817 / 1920);
    height: calc(100vh * 210 / 1080);
  }

  .bottom_left_view{
    width: 450px;
    height: calc(100vh * 300 / 1080);
    position: absolute;
    bottom: calc(100vh * 28 / 1080);
    left: calc(100% * 22 / 1920);
    animation: fadeInLeft 0.5s ease-out 0.5s both;

    .bottom_left_view_title{
      font-size: 64px;
      font-weight: 700;
      color: #fff;
      line-height: 100%;
      margin-bottom: calc(100% * 36 / 1080);
      letter-spacing: 3px;
    }

    .bottom_left_view_text{
      font-size: 16px;
      color: #fff;
      line-height: 25px;
      font-weight: 300;
    }

    .bottom_left_view_text_other{
      font-size: 22px;
      color: #fff;
      font-weight: bold;
      text-decoration: underline;
      text-align: right;
      padding-left: 5px;
      letter-spacing: 5px;
      text-underline-offset: 8px;
      text-decoration-thickness: 1px;
      cursor: pointer;
    }
  }

  // 添加动画定义
  @keyframes fadeInUpChat {
    0% {
      opacity: 0;
      transform: translateX(-51.1%) translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  .bottom_chat{
    border: 1px solid rgba(255, 255, 255, 1);
    width: calc(100vw * 530 / 1920);
    height: calc(100vh * 200 / 1080);
    border-radius: 20px;
    position: absolute;
    bottom: 0px;
    left:50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeInUpChat 0.5s ease-out 0s both;

    &.bottom_chat_expanded {
      width: calc(100vw * 707 / 1920);
      height: calc(100vh * 455 / 1080);
      left:51.1%;
      transform: translateX(-51.1%) scale(1) !important;
      opacity: 1;
      border: none;
      animation: none;
    }

    .bottom_chat_view{
      width: calc(100vw * 498 / 1920);
      height: calc(100vh * 170 / 1080);
      border-radius: 20px;
      border: 2px solid rgba(255, 255, 255, 1);
      backdrop-filter: blur(28.5px);
      background: linear-gradient(180deg, rgba(232, 255, 247, 0.7) 0.33%, rgba(168, 224, 255, 0.7) 100.33%);
      box-shadow: 0px 0px 22px 0px rgba(242, 242, 242, 0.5) inset;
      position: relative;
      display: flex;
      align-items: space-between;
      justify-content: center;
      flex-direction: column;

      &.bottom_chat_view_expanded {
        width: calc(100vw * 707 / 1920);
        height: calc(100vh * 455 / 1080);

        .bottom_chat_view_t{
          height: calc(100vh * 375 / 1080);
        }
      }

      .bottom_chat_view_t{
        width: 100%;
        height: 120px;
        display: flex;
        justify-content: center;

        .bottom_chat_view_t_chat{
          margin:5px 18px 0;
          width: calc(100% - 36px);
          height: calc(100% - 21px);
          
          .chat-messages-container {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            scroll-behavior: smooth;
            padding-top:5px;
            padding-right: 5px;
            color: rgba(62, 101, 122, 1);
            overscroll-behavior: contain; /* 防止滚动传播到父容器 */
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
              width: 4px;
            }
            
            &::-webkit-scrollbar-track {
              background: rgba(255, 255, 255, 0.1);
              border-radius: 2px;
            }
            
            &::-webkit-scrollbar-thumb {
              background: rgba(255, 255, 255, 0.5);
              border-radius: 2px;
              
              &:hover {
                background: rgba(255, 255, 255, 0.7);
              }
            }
            
            .chat-message {
              margin: 12px 0;
              
              &.user-message {
                display: flex;
                justify-content: flex-end;

                .message-icons {
                  display: flex;
                  align-items: center;
                  
                  .message-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin: 0 4px;
                  }
                  
                  .message-content {
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 1.4;
                    color: rgba(62, 101, 122, 0.8);
                  }
                }
              }
              
              &.bot-message {
                display: flex;
                justify-content: flex-start;
                
                .message-icons {
                  display: flex;
                  align-items: center;
                  
                  .message-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin: 0 4px;
                  }
                  
                  .message-content {
                    color: #2d3748;
                    border-radius: 18px 18px 18px 4px;
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 1.4;
                    color: rgba(62, 101, 122, 1);
                  }
                }
              }

              .typing-indicator {
                display: flex;
                align-items: center;
                padding: 8px 12px;
                
                span {
                  height: 6px;
                  width: 6px;
                  border-radius: 50%;
                  margin: 0 2px;
                  animation: typing 1.4s infinite ease-in-out;
                  
                  &:nth-child(1) { animation-delay: 0s; }
                  &:nth-child(2) { animation-delay: 0.2s; }
                  &:nth-child(3) { animation-delay: 0.4s; }
                }

                @keyframes typing {
                  0%, 60%, 100% {
                    transform: translateY(0);
                    opacity: 0.4;
                  }
                  30% {
                    transform: translateY(-5px);
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }

      .bottom_chat_view_b{
        width: 97%;
        height: 40px;
        margin-bottom: 5px;
        margin-left:9px;
        display: flex;
        border-radius: 10px;
        align-items: center;
        justify-content: center;
        background: rgba(240, 240, 240, 0.3);
        backdrop-filter: blur(15px);
        border: 1px solid;
        border-image-source: conic-gradient(from 102.21deg at 52.75% 38.75%, rgba(249, 249, 249, 0.5) -32.95deg, rgba(64, 64, 64, 0.5) 10.52deg, rgba(64, 64, 64, 0.35) 32.12deg, #FFFFFF 60.28deg, rgba(255, 255, 255, 0.5) 107.79deg, rgba(64, 64, 64, 0.35) 187.59deg, #F9F9F9 207.58deg, #FFFFFF 287.31deg, rgba(249, 249, 249, 0.5) 327.05deg, rgba(64, 64, 64, 0.5) 370.52deg);

        ::v-deep .el-textarea__inner{
          background: transparent !important;
          border: none!important;
          color: rgba(62, 101, 122, 1);
          resize: none;
          width: 100%;
          height: 100%;
        }

        .el-textarea_view{
            color: rgba(62, 101, 122, 1);
            font-size: 18px;
            font-weight: 400;
            border: none!important;
            background: transparent !important;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
        }

        ::v-deep .el-textarea__inner::placeholder {
            color: rgba(83, 138, 170, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /* 谷歌 */
        ::v-deep .el-textarea__inner::-webkit-input-placeholder {
            color: rgba(83, 138, 170, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /* 火狐 */
        ::v-deep .el-textarea__inner:-moz-placeholder {
            color: rgba(83, 138, 170, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /*ie*/
        ::v-deep .el-textarea__inner:-ms-input-placeholder {
            color: rgba(83, 138, 170, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }

        .bottom_chat_send{
          width:50px;
          height: 34px;
          background: linear-gradient(90deg, #96C3F9 0%, #7AFFE0 100%);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 1px;
          right: 8px;
          cursor: pointer;

          .bottom_chat_send_icon{
            width: 18px;
            height: 16px;
          }
        }
      }
    }
  }

  .bottom_right_view{
    width: calc(100vw * 433 / 1920);
    height: calc(100vh * 414 / 1080);
    border-radius: 24px;
    backdrop-filter: blur(12px);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 0px 22px 0px rgba(242, 242, 242, 0.5) inset;
    box-shadow: 0px 0px 0px 1px rgba(153, 153, 153, 1) inset;
    box-shadow: -2px -2px 1px -2px rgba(179, 179, 179, 1) inset;
    box-shadow: 2px 2px 1px -2px rgba(179, 179, 179, 1) inset;
    box-shadow: 3px 3px 0.5px -3.5px rgba(255, 255, 255, 0.5) inset;
    position: absolute;
    bottom: 0px;
    right:0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    animation: fadeInRight 0.5s ease-out 0.5s both;

    .bottom_right_view_img{
      width: calc(100vw * 310 / 1920);
      height: calc(100vh * 138 / 1080);
      margin: calc(100vh * 15 / 1080) auto calc(100vh * 5 / 1080);
    }

    .bottom_right_view_view{
      width: calc(100vw * 405 / 1920);
      height:calc(100vh - calc(100vh * 174 / 1080));
      position: relative;
      
      ::v-deep .el-carousel__container{
        border-radius: 20px;
        width: calc(100vw * 405 / 1920);
        height: calc(100vh * 211 / 1080);
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      }
      
      ::v-deep .el-carousel__item{
        border-radius: 20px;
        width: calc(100vw * 405 / 1920);
        height: calc(100vh * 211 / 1080);
      }

      ::v-deep .el-carousel__indicator.el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 0.5)!important;
        border-radius: 50%;
      }

      ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 1)!important;
        border-radius: 50%;
      }
      
      .bottom_right_view_view_v{
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        width: 100%;
        height: calc(100vh * 220 / 1080);
        border: 1px solid rgba(255, 255, 255, 0.2);
        display: flex;
        flex-direction: column;

        .bottom_right_view_view_v_title{
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          line-height: 24px;
          letter-spacing: 5px;
          margin: calc(100vh * 15 / 1080) auto 0;
        }

        .bottom_right_view_view_v_title_other{
          font-size: 16px;
          font-weight: 300;
          color: #fff;
          margin: calc(100vh * 5 / 1080) auto calc(100vh * 10 / 1080);
        }

        .bottom_right_view_view_v_info{
          margin: 0 43px;
          font-size: 14px;
          font-weight: 300;
          line-height: 21px;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
      }
    }
  }
}

.textRight{
  right: 0;
  position: absolute;
}

.textRight_1{
  right: 340px;
  position: absolute;
}

.text_1{
  font-size: 64px;
  font-weight: 700;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  letter-spacing: -5px;
  color: #fff;
}

.circle {
  width: 613px;
  height: 613px;
  border-radius: 50%;
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.top_1_img{
  width: 100vw;
  height: 100px;
  position: absolute;
  left: 0;
  top: 705px;
}

/* 各屏背景色 */
.section-1 {
  /* background: linear-gradient(180deg, rgba(1, 240, 155, 0.2) 0%, rgba(1, 140, 255, 0.6) 79.03%); */
  background: url(../assets/img/home/back_1.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
    width: 100%;
    height: 100%;
  }
}

.section-2 {
  position: relative;

  .section-2_lowest{
    width: 100%;
    height: 287px;
    background: linear-gradient(0deg, #7D9A90 20.97%, #84BEBE 60.48%, #66B8FB 100%);
    position: absolute;
    top: 0;
    left: 0;
  }

  .section-2_img{
    width: 789px;
    height: 286px;
    position: absolute;
    top: 0;
    left: 488px;
    z-index: 1;
  }

  .section-2_hover{
    width: 100%;
    height: 140px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .section-content_2{
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    width: 100%;
    height: 586px;
  }

  .section-2_text{
    font-size: 46px;
    font-weight: 700;
    font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
    color: #fff;
    position: absolute;
    top: 135px;
    left: 716px;
    z-index: 4;
    text-align: center;
    line-height: 56px;
    letter-spacing: 8px;
  }

  .section-2_top{
    position: absolute;
    top: 143px;
    left: 131px;
    width: calc(100% - 260px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 4;

    .section-2_top_l{
      display: flex;
      flex-direction: column;

      .section-2_top_l_title{
        font-size: 40px;
        font-weight: 700;
        color: rgba(81, 202, 216, 1);
        line-height: 40px;
        letter-spacing: 2px;
      }

      .section-2_top_l_info{
        font-size: 26px;
        font-weight: 400;
        color: rgba(26, 137, 154, 1);
        margin-bottom: 15px;
        font-family: 'Inter';
      }
    }

    .section-2_top_r{
      display: flex;
      flex-direction: column;
      width: 415px;

      .section-2_top_l_title{
        font-size: 40px;
        font-weight: 700;
        color: rgba(81, 202, 216, 1);
        line-height: 40px;
        letter-spacing: 2px;
      }

      .section-2_top_l_info{
        font-size: 26px;
        font-weight: 400;
        color: rgba(26, 137, 154, 1);
        margin-bottom: 15px;
        font-family: 'Inter';
      }

      .rLine{
        width: 100%;
        height: 1px;
        background: rgba(124, 191, 200, .5);
        margin-bottom: 15px;
      }

      .flexStyle{
        display: flex;
        justify-content: space-between;
        color: rgba(31, 100, 104, 1);
      }
    }
  }

  .section-2_bottom{
    position: absolute;
    bottom: 0;
    left: 131px;
    width: calc(100% - 260px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 4;

    .section-2_bottom_l{
      display: flex;
      flex-direction: column;
      width:670px;

      .section-2_bottom_l_title{
        font-family: Inter;
        font-weight: 700;
        font-size: 64px;
        line-height: 70px;
        letter-spacing: 5px;
        color: rgba(31, 100, 104, 1);
      }

      .section-2_bottom_l_info{
        font-family: Inter;
        font-weight: 400;
        font-size: 28px;
        line-height: 36px;
        letter-spacing: 2px;
        color: rgba(110, 172, 181, 1);
        margin-top:70px;
        margin-bottom:73px;
      }

      .section-2_bottom_l_view{
        width:295px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient(180deg, #ADF9DF 0%, #89D3FF 100%);
        border-radius: 10px;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 2px;
        color: rgba(31, 100, 104, 1);
        padding-left:28px;
        cursor: pointer;
        font-family: Inter;

        .section-2_bottom_l_view_img{
          width: 21px;
          height: 19px;
          margin-right: 14px;
        }
      }
    }

    .section-2_bottom_r{
      display: flex;
      flex-direction: column;
      width: 845px;
      align-items: center;

      .section-2_bottom_r_view{
        width:100%;
        background: linear-gradient(137.47deg, rgba(255, 255, 255, 0.3) 11.08%, rgba(248, 250, 255, 0.8) 39.07%, rgba(245, 248, 255, 0.9) 60.7%, rgba(255, 255, 255, 0.2) 95.9%);
        border: 0.5px solid;
        border-image-source: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.2) 100%);
        box-shadow: 9.25px 13.75px 2px 0px rgba(255, 223, 220, 0.13);
        backdrop-filter: blur(1px);
        box-shadow: 0.75px 3px 7.7px 0px rgba(255, 213, 209, 0.43) inset;
        box-shadow: -1px -3.25px 9.07px 0px rgba(255, 255, 255, 1) inset;
        box-shadow: 9px 12px 19px -3px rgba(0, 0, 0, 0.25);
        margin-bottom:30px;
        min-height: 130px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .section-2_bottom_r_view_v{
          padding: 10px 40px;
          position: relative;

          .section-2_bottom_r_view_title{
            font-family: Inter;
            font-weight: 700;
            font-size: 36px;
            letter-spacing: 2px;
            vertical-align: middle;
            color: rgba(57, 187, 216, 1);

            span{
              font-size: 28px;
              color: rgba(26, 137, 154, 1);
            }
          }

          .section-2_bottom_r_view_info{
            font-family: Inter;
            font-weight: 500;
            font-size: 24px;
            letter-spacing: 2px;
            line-height: 24px;
            color: rgba(110, 172, 181, 1);

            span{
              font-weight: 700;
              color: rgba(26, 137, 154, 1);
            }
          }
        }

        .borderLine{
          height: 10px;
          background: linear-gradient(90deg, #00FA91 0%, #008BFF 100%);
          position: absolute;
          left: 0;
          top: -5px;
        }
      }
    }
  }
}

.section-3 {
  // background-color: #fff;
  background: linear-gradient(180deg, #306F99 0%, #CAFFED 80%);
  height: 100vh;
  position: relative;
  overflow: hidden;

  .vue-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .section-3-content {
      // min-height: 2000px;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      // margin-top:140px;

      .section-3-content_top{
        width: 100%;
        height: calc(100vh * 550 / 1080);
        display: flex;
        justify-content: center;
        align-items: center;
        
        .section-3-content_top_view{
          width:1100px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .section-3-content_top_view_top{
            font-family: Inter;
            font-weight: 700;
            font-size: 58px;
            letter-spacing: 15px;
            line-height: 65px;
            text-align: center;
            color: rgba(255, 255, 255, 1);
          }

          .section-3-content_top_view_line{
            width: 100%;
            height: 2px;
            margin: 27px 0 19px;
            background: linear-gradient(90deg, #7CB3EA 0%, #BFFAFA 100%);
          }

          .section-3-content_top_view_bottom{
            font-family: Inter;
            font-weight: 400;
            font-size: 32px;
            letter-spacing: 10px;
            line-height: 42px;
            text-align: center;
            color: rgba(215, 253, 255, 1);
          }
        }
      }
    }
  }
}

.section-4 {
  background-color: #f39c12;
}
</style>